import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4
  }
});

class ExpandableListItem extends React.Component {
  state = {
    open: false
  };

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleRedirect = url => {
    this.props.history.push(url);
  };

  render() {
    const { classes, text, listItems } = this.props;

    return (
      <div>
        <ListItem button onClick={this.handleClick}>
          <ListItemText inset primary={text} />
          {this.state.open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={this.state.open} timeout='auto' unmountOnExit>
          <List component='div' disablePadding>
            {listItems.map((e, i) => (
              <ListItem
                onClick={() => this.handleRedirect(e.url)}
                key={i.toString()}
                button
                className={classes.nested}
              >
                <ListItemText key={i.toString()} inset primary={e.text} />
              </ListItem>
            ))}
          </List>
        </Collapse>
      </div>
    );
  }
}

ExpandableListItem.propTypes = {
  classes: PropTypes.element.isRequired
};

export default withStyles(styles)(withRouter(ExpandableListItem));
